export const getInitialValue = (value) => {
  if (![null, undefined].includes(value)) {
    return value;
  }
  return null;
};

export const getFormikValue = (value) => {
  if (![null, undefined].includes(value)) {
    return value;
  }
  return '';
};

export const isDisplayShrink = (value) => {
  if (![null, undefined, ''].includes(value)) {
    return true;
  }
  return false;
};

export const onChangeWithInitReturn =
  (name, formik, isNumber = false) =>
  (e) => {
    const initValue = formik.initialValues[name];
    const value =
      e.target.value === '' && (!initValue || initValue === '')
        ? initValue
        : e.target.value;

    formik.setFieldValue(name, isNumber ? parseFloat(value) : value);
  };
